"use strict";

var bmp = require('bmp-js');

var fileType = require('file-type');

module.exports = function (TessModule, iBuf, yres) {
  if (yres === void 0) {
    yres = 70;
  }

  var buf = Buffer.from(iBuf);
  var type = fileType(buf);
  var bytesPerPixel = 0;
  var data = null;
  var pix = null;
  var w = 0;
  var h = 0;
  /*
   * Although leptonica should support reading bmp, there is a bug of "compressed BMP files".
   * As there is no solution, we need to use bmp-js for now.
   * @see https://groups.google.com/forum/#!topic/tesseract-ocr/4mPD9zTxdxE
   */

  if (type && type.mime === 'image/bmp') {
    var bmpBuf = bmp.decode(buf);
    data = TessModule._malloc(bmpBuf.data.length * Uint8Array.BYTES_PER_ELEMENT);
    TessModule.HEAPU8.set(bmpBuf.data, data);
    w = bmpBuf.width;
    h = bmpBuf.height;
    bytesPerPixel = 4;
  } else {
    var ptr = TessModule._malloc(buf.length * Uint8Array.BYTES_PER_ELEMENT);

    TessModule.HEAPU8.set(buf, ptr);
    pix = TessModule._pixReadMem(ptr, buf.length);

    if (TessModule.getValue(pix + 7 * 4, 'i32') === 0) {
      /*
       * Set a yres default value to prevent warning from tesseract
       * See kMinCredibleResolution in tesseract/src/ccstruct/publictypes.h
       */
      TessModule.setValue(pix + 7 * 4, yres, 'i32');
    }

    var _Array$fill$map = Array(2).fill(0).map(function (v, idx) {
      return TessModule.getValue(pix + idx * 4, 'i32');
    });

    w = _Array$fill$map[0];
    h = _Array$fill$map[1];
  }

  return {
    w: w,
    h: h,
    bytesPerPixel: bytesPerPixel,
    data: data,
    pix: pix
  };
};